let wasmBasePath;
export function setWasmBasePath(basePath) {
    wasmBasePath = basePath || undefined;
}
export function getWasmBasePath() {
    return wasmBasePath;
}
export function setWasmBasePathFromConfig(decodeConfig) {
    if (decodeConfig?.wasmBasePath !== undefined) {
        setWasmBasePath(decodeConfig.wasmBasePath);
    }
}
export function resolveWasmUrl(fileName, defaultUrl) {
    if (!wasmBasePath) {
        return defaultUrl.toString();
    }
    const base = wasmBasePath.endsWith('/') ? wasmBasePath : `${wasmBasePath}/`;
    const path = `${base}${fileName}`;
    const href = typeof self !== 'undefined' ? self.location?.href : undefined;
    if (!href) {
        return path;
    }
    try {
        return new URL(path, href).toString();
    }
    catch {
        return path;
    }
}
